
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 68.93 45.63"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64.69 19.35H11.85l13.43-13.4a3.472 3.472 0 00-4.91-4.91L1.03 20.36a3.18 3.18 0 00-.44.53c-.05.08-.08.16-.13.24a2.47 2.47 0 00-.19.36c0 .1-.06.21-.1.31s-.07.22-.1.34a3.29 3.29 0 00-.05.54V22.97a4.57 4.57 0 00.05.52c0 .12.07.24.11.36a2.29 2.29 0 00.09.28c.06.14.13.26.2.39l.11.21a3.39 3.39 0 00.45.54l19.34 19.34a3.43 3.43 0 002.45 1 3.48 3.48 0 002.46-5.93L11.91 26.29h52.78c2.34 0 4.24-1.55 4.24-3.46s-1.9-3.46-4.24-3.46z","fill":"#707070"}})])
          )
        }
      }
    